import React, { useEffect, useState } from 'react';
import '../css/Main.css';
import XBar from "../elements/XBar";
import Events from "./Events";
import Faq from "./Faq";
import Book from "./Book";
import Profile from "./Profile";
import Music from "./Music";

// Принимаем user и setUser, которые пришли из App.js
const MainPage = ({ user, setUser }) => {
    const [activeTab, setActiveTab] = useState(1);

    const renderContent = () => {
        switch (activeTab) {
            case 0:
                return <Faq user={user} />;
            case 2:
                return <Events />;
            case 1:
                return <Book />;
            case 3:
                return <Music />;
            case 4:
                // Передаем данные пользователя и функцию выхода в Profile
                return <Profile user={user} onLogout={setUser} setUser={setUser} />;
            default:
                return <div>Выберите раздел</div>;
        }
    };

    return (
        <div className="Main">
            <div className="Content">
                {renderContent()}
            </div>
            <XBar activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
    );
};

export default MainPage;